import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {SelectOption} from '../../model/SelectOption';

@Component({
    selector: 'app-m-filter-modal',
    templateUrl: './m-filter-modal.component.html',
    styleUrls: ['./m-filter-modal.component.scss']
})
export class MFilterModalComponent implements OnInit {

    public static TYPE_TEXT = 0;
    public static TYPE_NUMBER = 10;
    public static TYPE_SELECT = 20;
    public static TYPE_DATE = 30;

    public filters: { [key: string]: {label: string, type: number, value: any}; } = {};
    public filterKeys: Array<string> = [];
    public filterOptions: { [key: string]: Array<SelectOption> } = {};

    public enableSort: boolean;
    public sortColumn: string;
    public sortDirection: string;
    public sortColumnOptions: Array<SelectOption>;

    public mFilterModalComponentRef = MFilterModalComponent;

    @Output() onApply = new EventEmitter();

    constructor(
        public dialogRef: MatDialogRef<MFilterModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit() {
        this.enableSort = this.data.hasOwnProperty('enableSort') && this.data.enableSort;
        this.sortColumn = (this.enableSort && this.data.hasOwnProperty('sortColumn')
            && this.data.sortColumn && this.data.sortColumn.trim() !== '')
            ? this.data.sortColumn : null;
        // discourage any other sortDirection values from being used other than DESC, ASC
        this.sortDirection = (this.enableSort && this.data.hasOwnProperty('sortDirection') && this.data.sortDirection === 'DESC')
            ? this.data.sortDirection : 'ASC';
        this.sortColumnOptions = (this.enableSort && this.data.hasOwnProperty('sortColumnOptions')) ? this.data.sortColumnOptions : [];

        // load fields
        for (const key of Object.keys(this.data.filters)) {
            this.filters[key] = {label: this.data.filters[key].label, type: this.data.filters[key].type, value: null};
        }
        // populate values
        for (const key of Object.keys(this.data.filterParams)) {
            if (this.filters.hasOwnProperty(key)) {
                this.filters[key].value = this.data.filterParams[key];
            }
        }
        // populate filter options
        for (const key of Object.keys(this.data.filterOptions)) {
            if (this.filters.hasOwnProperty(key)) {
                this.filterOptions[key] = this.data.filterOptions[key];
            }
        }
        this.filterKeys = Object.keys(this.filters);
    }

    onClearClick() {

    }

    onApplyClick() {
        const appliedFilters = {};
        for (const key of Object.keys(this.filters)) {
            if (this.filters[key].value !== null && this.filters[key].value !== '') {
                appliedFilters[key] = this.filters[key].value;
            }
        }
        if (this.enableSort) {
            if (this.sortColumn !== '' && this.sortDirection !== '') {
                appliedFilters['SORT_COLUMN'] = this.sortColumn;
                appliedFilters['SORT_DIRECTION'] = this.sortDirection;
            }
        }
        this.onApply.emit(appliedFilters);
        this.closeDialog();
    }

    onCancelClick() {
        this.closeDialog();
    }

    clearField(filterKey) {
        this.filters[filterKey].value = null;
    }

    toggleSort() {
        if (this.sortDirection === 'ASC') {
            this.sortDirection = 'DESC';
        } else {
            this.sortDirection = 'ASC';
        }
    }

    private closeDialog() {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/components/filter-modal/m-filter-modal.component.ts